module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.700d4c84.png";